import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Batch } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reconcileBatch = createAsyncThunk<
  Batch,
  string,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RECONCILE_BATCH, async (batchId, { extra }) => {
  return await extra.batchesRepo.reconcileBatch(batchId);
});
